<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/instoreBanner_m.png"/>

      <top-nav></top-nav>

    </div>

    <div class="instoreContent">
      <div class="">
        <div class="rightTopImg" id="m1"><img :class="animates.mm1 ? 'fadeInUp animated' : 'hideBox'" src="../../../assets/img/onlineImg1.jpg"/></div>
        <div class="contentsTextBox">
          <div class="instore01"></div>
          <div class="instore02" id="m2">
            <div class="leftBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
              <div class="leftBorder"></div>
              <div class="textBox">
                <div class="texts">
                  <div class="titles">线上支付产品</div>
                  <div class="contents">我们为PC网站，移动网站，购物App，微信支付和支付宝小程序提供支付解决方案，使客户在线购买时可以使用人民币支付.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="instore03">

            <div class="instore03_row" id="m3">
              <div class="instore03_left animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">网页二维码支付</div>
                <div class="contents">我们为电脑网站提供支付解决方案，消费者可以扫描网站上的二维码进行支付.</div>
              </div>


              <div class="animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container animated">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">客户在商户网站上进行购物</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row1_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">选择支付宝/微信支付作为支付方式</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row1_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">输入支付密码</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row1_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">支付成功</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row1_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>

            <div class="instore03_row" id="m4">
              <div class="instore03_left animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">移动设备网页</div>
                <div class="contents">我们为移动网络终端提供支付解决方案，消费者下订单后可以通过支付宝或微信支付付款.</div>
              </div>

              <div class="animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">客户使用智能手机在商家网站上进行交易</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row2_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">选择支付宝/微信支付作为支付方式</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row2_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">输入支付密码</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row2_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">支付成功</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row2_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>

            <div class="instore03_row" id="m5">
              <div class="instore03_left animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">移动App接口</div>
                <div class="contents">SDK（移动应用程序）网关允许客户在移动应用程序上下订单</div>
              </div>

              <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">客户在购物App中消费</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row3_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">在购物后进行结账</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row3_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">输入支付密码</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row3_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">支付成功</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row3_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>

            <div class="instore03_row" id="m6">
              <div class="instore03_left animated" :class="animates.mm6 ? 'fadeInUp' : 'hideBox'">
                <div class="titles">小程序接口</div>
                <div class="contents">适用于支付宝/微信支付小程序，消费者可以在小程序中完成付款.</div>
              </div>

              <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
                <div class="swiper-container">
                  <div class="swiper-wrapper instore03_ul">
                    <div class="swiper-slide instore03_li">
                      <div class="topText">客户在微信或支付宝迷你程序中下订单</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row4_icon1.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">选择支付宝/微信支付作为支付方式</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row4_icon2.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">输入支付密码</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row4_icon3.png"/></div>
                    </div>
                    <div class="swiper-slide instore03_li">
                      <div class="topText">支付成功</div>
                      <div class="bottomIcon"><img src="../../../assets/icon/online_row4_icon4.png"/></div>
                    </div>
                  </div>
                  <!-- 如果需要分页器 -->
                  <div class="swiper-pagination"></div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                  <!-- 如果需要滚动条 -->
                  <!--<div class="swiper-scrollbar"></div>-->
                </div>
              </div>

            </div>

          </div>
          <div class="instore04" id="m7">
            <ul class="instore04_ul animated" :class="animates.mm7 ? 'fadeInUp' : 'hideBox'">
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon1.png"/></div>
                <div class="titles">T + 1” 自动清算</div>
                <div class="contents">我们会在在“T + 1”个工作日内自动结算您的交易.</div>
              </li>
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon2.png"/></div>
                <div class="titles">银行级资金安全</div>
                <div class="contents">我们获得澳大利亚金融许可，并严格遵守AML（反洗钱）和AF（反欺诈）风险控制法规.</div>
              </li>
              <li class="instore04_li">
                <div class="iconBox"><img src="../../../assets/icon/instore_row4_icon3.png"/></div>
                <div class="titles">多平台账户管理系统</div>
                <div class="contents">一站式财务数据管理，便捷的后台操作和完整的统计功能.</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "PaymentOnline_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
          mm6:false,
          mm7:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      new Swiper('.swiper-container', {
        loop:true,
        autoplay:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:".swiper-pagination",
          clickable:true,
        },
        navigation:{
          prevEl:".swiper-button-prev",
          nextEl:".swiper-button-next",
        }
      });

        document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      this.animates.mm2 = true;
      this.animates.mm3 = true;

        window.addEventListener('scroll', this.handleScroll)

    },
    methods:{
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        // var offsetTop2 = document.querySelector('#m2').offsetTop;
        // var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;
        var offsetTop6 = document.querySelector('#m6').offsetTop;
        var offsetTop7 = document.querySelector('#m7').offsetTop;



        if (scrollTop > offsetTop4-20) {
          this.animates.mm4 = true
        } else {
          this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-220) {
          this.animates.mm5 = true
        } else {
          this.animates.mm5 = false
        }
        if (scrollTop > offsetTop6-220) {
          this.animates.mm6 = true
        } else {
          this.animates.mm6 = false
        }
        if (scrollTop > offsetTop7-220) {
          this.animates.mm7 = true
        } else {
          this.animates.mm7 = false
        }
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .instoreContent .swiper-container {
    width: 100%;
    height: auto;
    padding-bottom: 40px;
  }

  /*body{min-width: 1345px;}*/
  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .instore04{width: 100%;height: auto;padding: 5rem 0;}
  .instore04 .instore04_ul{width: 100%;height: auto;}
  .instore04 .instore04_ul .instore04_li{width:calc(100% - 100px);height: auto;padding: 40px 50px;}
  .instore04 .instore04_ul .instore04_li .iconBox{width: 100%;height: 10rem;text-align: center;}
  .instore04 .instore04_ul .instore04_li .iconBox>img{max-height: 100%;}
  .instore04 .instore04_ul .instore04_li .titles{font-size: 1rem;color: #4a4a4a;font-family: MontserratMedium;width: 100%;text-align: center;line-height: 2rem;}
  .instore04 .instore04_ul .instore04_li .contents{font-size: 0.875rem;font-family: Montserrat300;color: #4a4a4a;width: 100%;text-align: center;line-height: 1.8rem;margin-top: 1rem;}




  /*内容部分*/
  .instoreContent{width: 100%;height: auto;padding: 1rem 0 0rem 0;background-color: #fff;}
  .instoreContent .rightTopImg{position: absolute;width: 90%;height: auto;text-align: right;right: 0;z-index: 1;max-width: 650px;}
  .instoreContent .rightTopImg>img{width: 100%}


  .instoreContent .contentsTextBox{width: 100%;height: auto;position: relative;z-index: 2;}
  .instore01{width: 100%;height: 7rem;}
  .instore02{width: 100%;height: auto;min-height: 7rem;}
  .instore02 .leftBox{width: calc(100% - 30px);box-shadow: 0 0 15px 1px rgba(0,0,0,0.3);padding: 1rem 0; margin-left:15px;float: left;height: 100%;background-color: #fff;position: relative;display: flex;align-items: center;}
  .instore02 .leftBox .leftBorder{align-items: center;width: 4px;height: 70px;background-color: #0076ff;}
  .instore02 .leftBox .textBox{width: 80%;height: calc(100% - 2px);display: flex;align-items: center;margin-left: 2rem;}
  .instore02 .leftBox .textBox .texts{width: 100%;height: 60%;margin: auto;align-items: center;}
  .instore02 .leftBox .textBox .texts .titles{font-size: 1.125rem;font-family: OpenSans600;line-height: 2rem;color: #6d7278;}
  .instore02 .leftBox .textBox .texts .contents{font-size: 0.75rem;font-family: Montserrat300;color: #6d7278;line-height: 1.3rem;}


  .instore03{width: 100%;height: auto;background-color: #fff;}
  .instore03 .instore03_row{width: calc(100% - 30px);height: auto;padding: 60px 15px;}
  .instore03 .instore03_row .instore03_left{width: 70%;height: 100%;margin: auto;}
  .instore03 .instore03_row .instore03_left .titles{color: #6d7278;font-size: 1rem;font-family: Montserrat600;line-height: 3rem;text-align: center;}
  .instore03 .instore03_row .instore03_left .contents{font-size: 0.875rem;font-family: Montserrat300;color: #6d7278;line-height: 1.6rem;text-align: center;}
  .instore03 .instore03_row .instore03_ul{width: 100%;height: auto;margin-top: 50px;}
  .instore03 .instore03_row .instore03_ul .instore03_li{width: 100%;height: 100%;padding: 0;}
  .instore03 .instore03_row .instore03_ul .instore03_li .topText{width: 9rem;height: 3rem;margin: auto; font-family: Montserrat300;font-size: 0.875rem;color: #6d7278;line-height: 1.1rem;text-align: center;}
  .instore03 .instore03_row .instore03_ul .instore03_li .bottomIcon{width: 100%;height: 13rem;display: flex;align-items: center;}
  .instore03 .instore03_row .instore03_ul .instore03_li .bottomIcon>img{max-width: 100%;max-height: 100%;align-items: center;margin: auto;}

  .hideBox{display: none;}

</style>
